module.exports = __webpack_public_path__ + "img/11.748d5e33.png";